import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class JhiParseLinks {
  // Very small subset implementation for parsing 'link' header
  parse(header: string | null): any {
    if (!header) {
      return {};
    }
    const links: any = {};
    header.split(',').forEach((part) => {
      const section = part.split(';');
      if (section.length !== 2) {
        return;
      }
      const url = section[0].trim().replace(/<(.*)>/, '$1');
      const name = section[1].trim().replace(/rel="(.*)"/, '$1');
      links[name] = url;
    });
    return links;
  }
}
